import React from 'react';
import Icon from './Icon';

interface ConfirmDialogProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open, title, message, confirmLabel = 'Delete', cancelLabel = 'Cancel',
  danger = true, onConfirm, onCancel,
}) => {
  if (!open) return null;

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-label={title}
      className="fh-confirm-backdrop"
      onClick={onCancel}
    >
      <div className="fh-confirm-card" onClick={e => e.stopPropagation()}>
        <div className="fh-confirm-header">
          <div className={`fh-confirm-icon ${danger ? 'fh-confirm-icon--danger' : 'fh-confirm-icon--info'}`}>
            <Icon name={danger ? 'delete' : 'info'} size={22} color={danger ? '#ef5350' : '#4fc3f7'} />
          </div>
          <h3 className="fh-confirm-title">{title}</h3>
        </div>
        <p className="fh-confirm-message">{message}</p>
        <div className="fh-confirm-actions">
          <button onClick={onCancel} className="fh-confirm-btn fh-confirm-btn--cancel">
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            autoFocus
            className={`fh-confirm-btn fh-confirm-btn--confirm ${danger ? 'is-danger' : 'is-info'}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
